import { FieldPath, UseFormSetError } from 'react-hook-form';
import { ZodError } from 'zod';
import { WorkFormContext } from '../../work-form.types';

export const applyMultiDayZodErrors = (
  error: ZodError,
  setError: UseFormSetError<WorkFormContext>
): void => {
  error.issues.forEach((issue) => {
    const fieldPath = issue.path.map(String).join('.') as FieldPath<WorkFormContext>;
    setError(fieldPath, { message: issue.message });
  });
};
